<template>
    <div class="custom-select-container position-relative">
        <div class="custom-select" @click="toggleDropdown">
            <div class="d-flex flex-column container-title-and-option">
                <span class="label-custom-select">{{ label }}</span>
                <div class="custom-select-value">{{ modelValue?.value || '' }}</div>
            </div>
            <div class="custom-select-icon">
                <img src="/icon/arrow_down.svg" class="arrow-collapse-custom-select" :class="{ 'open': dropdownActive }" alt="{{ $t('expand_the_list') }}" />
            </div>
        </div>
        <div v-show="dropdownActive" class="custom-options">
            <div v-for="option in options" :key="option.id" class="custom-option" @click="selectOption(option)">
                {{ option.value }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
type Option = { id: string | number; value: string | number }

const props = defineProps<{
    modelValue?: Option;
    label: string;
    options: Option[]; }>();


const emit = defineEmits<{ (e: 'update:modelValue', value: { id: string | number; value: string | number }): void }>();
// const selectedOption = ref(props.modelValue);
const dropdownActive = ref(false);

const toggleDropdown = () => {
    dropdownActive.value = !dropdownActive.value;
};
const selectOption = (option: Option) => {
    emit('update:modelValue', option);
    dropdownActive.value = false;
};

</script>

<style scoped lang="scss">
.arrow-collapse-custom-select.open {
    transform: rotate(180deg);
}
.label-custom-select {
    color: #aaa;
    font-family: Roboto;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
}
.container-title-and-option {
    gap: 4px;
}

.custom-select-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    font-family: Roboto;

    .custom-select {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 9px 16px;
        border-radius: 3px;
        border: 1px solid var(--main-grey-E4E6E7, #e4e6e7);
        background-color: var(--main-white-FFFFFF, #fff);
        position: relative;
        cursor: pointer;

        &-value {
            flex-grow: 1;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
        }

        &-icon {
            margin-left: 12px;
        }
    }

    .custom-options {
        padding: 12px;
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        border: 1px solid var(--main-grey-E4E6E7, #e4e6e7);
        background-color: var(--main-white-FFFFFF, #fff);
        box-shadow: 0px 4px 16px 0px rgba(209, 209, 209, 0.25);
        z-index: 1000;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 125% */
        gap: 4px;
        max-height: 500px;
        overflow: scroll;

        .custom-option {
            padding: 8px 16px;
            border-radius: 3px;
            &:hover {
                color: var(--other-blue-48538B, #48538b);
                background: var(--grey-08-F7F9FB, #f7f9fb);
            }
        }
    }
}
</style>
